export default {"src":"/_next/static/media/MARKETPLACE_ICON.fd567331.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};